import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addDockageFeeListData,
  deleteDockageFeeListData,
  fetchDockageFeeList,
  updateDockageFeeListData,
} from "../../apis/dockageFee";


export const fetchDockageFeeDatas = createAsyncThunk(
  "dockageFee/fetchDockageFee",
  async (_, { rejectWithValue }) => {
    try {
      const fees = await fetchDockageFeeList();
      return fees;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },{
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.dockageFeeList.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updateDockageFee = createAsyncThunk(
  "dockageFee/updateDockageFee",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        dockageFeeId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateDockageFeeListData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDockageFee = createAsyncThunk(
  "dockageFee/deleteDockageFee",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteDockageFeeListData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewDockageFeeData = createAsyncThunk(
  "dockageFee/deleteDockageFeeData",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addDockageFeeListData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
